import BaseTooltip from 'components/BaseTooltip'
import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Button } from '@mui/material'

import { fetchManagerPairings } from '../duck/actions'
import { isDealManagerSearchEnabled } from '../duck/selectors'

export type DealSearchButtonProps = ExtendableStyles & Testable & { disabled?: boolean }

export function DealSearchButton(props: DealSearchButtonProps) {
  const dispatch = useDispatch()
  const triggerFetch = useCallback(() => {
    dispatch(fetchManagerPairings.request())
  }, [dispatch])
  const isEnabled = useSelector(isDealManagerSearchEnabled)
  const { disabled = false } = props

  return (
    <BaseTooltip
      title={!isEnabled ? 'Please include any of the provided filters to enable the search' : undefined}
      wrapped
    >
      <Button onClick={triggerFetch} variant="contained" color="secondary" disabled={!isEnabled && disabled} {...props}>
        Search
      </Button>
    </BaseTooltip>
  )
}
